import { connect } from 'react-redux';
import { addToBlacklistAction } from '../../../../store/redux/actions/clientAdminActions';
import { AddToBlackList } from './AddToBlackList';

const mapDispatchToProps = dispatch => ({
  addToBlacklist: payload => dispatch(addToBlacklistAction.request(payload))
});

export default connect(null, mapDispatchToProps)(AddToBlackList);
